module.exports = __webpack_public_path__ + "media/native-apps/nacka-59a2e959.webp";